import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet } from 'APIPackage/MainModule/common/apiTools';

export async function fetchKnmYears(): Promise<number[]> {
  return apiGet<number[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/years`);
}
